import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const LogsIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M1.25 18.125V1.87501C1.25 1.52981 1.5298 1.25001 1.875 1.25001H11.25V3.75001C11.25 4.44036 11.8096 5.00001 12.5 5.00001H15V6.87501H16.25V4.37501C16.251 4.20888 16.1857 4.04919 16.0687 3.93126L12.3187 0.18126C12.2008 0.0642678 12.0411 -0.000927527 11.875 9.97262e-06H1.875C0.839453 9.97262e-06 0 0.839502 0 1.87501V18.125C0 19.1606 0.839453 20 1.875 20H6.25V18.75H1.875C1.52984 18.75 1.25 18.4702 1.25 18.125Z"
    />
    <path
      fill={color}
      d="M18.75 12.5H17.5V13.75H18.75V15H16.25V11.25H20C20 10.5597 19.4404 10 18.75 10H16.25C15.5596 10 15 10.5597 15 11.25V15C15 15.6904 15.5596 16.25 16.25 16.25H18.75C19.4404 16.25 20 15.6904 20 15V13.75C20 13.0597 19.4404 12.5 18.75 12.5Z"
    />
    <path
      fill={color}
      d="M11.875 10C10.4943 10 9.375 11.1193 9.375 12.5V13.75C9.375 15.1307 10.4943 16.25 11.875 16.25C13.2557 16.25 14.375 15.1307 14.375 13.75V12.5C14.375 11.1193 13.2557 10 11.875 10ZM13.125 13.75C13.125 14.4404 12.5654 15 11.875 15C11.1846 15 10.625 14.4404 10.625 13.75V12.5C10.625 11.8097 11.1846 11.25 11.875 11.25C12.5654 11.25 13.125 11.8097 13.125 12.5V13.75Z"
    />
    <path
      fill={color}
      d="M6.25 10H5V15.625C5 15.9702 5.2798 16.25 5.625 16.25H8.75V15H6.25V10Z"
    />
  </svg>
);

LogsIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

LogsIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(20, 20),
};

export default LogsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/logs-v2.js